import stylesheet0 from "@salesforce-ux/c360-grid/dist/index.css";

function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".modal-footer" + shadowSelector + " {padding-top: 2rem;justify-content: flex-end;text-align: right;}.modal-content" + shadowSelector + " {padding-top: 1rem;}ads-button" + shadowSelector + " ads-icon" + shadowSelector + " {padding-left: 10px;padding-right: 6px;}.right-padding" + shadowSelector + " {padding-right: 20px;}.button-padding" + shadowSelector + " {padding: 2px 0px;padding-left: 6px;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet0, stylesheet];